<template>
    <div class="d-block">
      <v-skeleton-loader
        class="mx-auto"
        type="list-item-avatar-two-line"
        min-height="120"
      ></v-skeleton-loader>
      <v-skeleton-loader
        class="mx-auto"
        type="list-item-avatar-three-line"
        min-height="120"
      ></v-skeleton-loader>
    </div>
</template>

<script>
    export default {
        name: "profileCommentsTimelineBoiler"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Boilerpalettes/profileCommentsTimelineBoiler.vue